import '../../style/base.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/swipe-cell/style/index.js
// module id = 180
// module chunks = 31